function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ANDROID_APP_DOWNLOAD_LINK, IOS_APP_DOWNLOAD_LINK, LONG_FOOTER_BOTTOM_LINKS } from "/constants/links";
import classNames from "classnames";
import LanguagePickerComponent from "/components/core/language-picker/language-picker-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { DIALOG_DIRECTIONS } from "components/core/language-picker/language-picker-service";
import AccessibilityStatementLinkComponent from "components/accessibility/accessibility-statement-link/accessibility-statement-link-component";
import GooglePlayBig from "static/svg/social/google_play_big.svg";
import AppStoreBig from "static/svg/social/app_store_big.svg";
import PaletteIconsComponent from "./palette-icons/palette-icons-component";
import { StyledFooterBottomBarComponent } from "./footer-bottom-bar-component.scss";
import linkTypesComponents from "./links/index.js";
import SecurityLogosComponent from "../security-logos/security-logos-component";
import AllRightsReservedComponent from "../all-rights-reserved/all-rights-reserved-component";
import VisibilitySensor from "react-visibility-sensor";
import { trackEvent } from "/services/bigbrain-service";
import { FOOTER_BOTTOM_BAR_VIEWD_VIEWD } from "/constants/bigbrain-event-types";
import Title from "segments/desktop/core-components/title/title";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import { LG, SM } from "components/core/new-button/button-component";
import { shouldGetContactSalesInTheFooter } from "services/ab-tests/acquisition-ab-test-service";
import { CONTACT_SALES_PAGE_LINK } from "constants/links";
import { FOOTER_CONTACT_SALES_BUTTON_CLICKED } from "constants/bigbrain-event-types";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { withAbTests } from "contexts/ab-tests-context";
const FooterBottomBarComponent = (props)=>{
    const { localeId, SocialFooterLinks, footerType, simulateContactSalesButtonInTheFooter, abTests, translate, hideContactSalesInFooter } = props;
    const onVisibilityChange = (isVisible)=>{
        if (isVisible) {
            trackEvent(FOOTER_BOTTOM_BAR_VIEWD_VIEWD, {
                kind: footerType
            });
        }
    };
    const renderLinks = ()=>{
        return LONG_FOOTER_BOTTOM_LINKS.map((linkData)=>{
            const { title, componentName } = linkData;
            const ComponentToRender = linkTypesComponents[componentName];
            // if link is locale specific
            if (linkData.localeId && linkData.localeId !== localeId) {
                return null;
            }
            return /*#__PURE__*/ _jsx("div", {
                className: classNames("short-footer-link-component-wrapper"),
                children: /*#__PURE__*/ _jsx(ComponentToRender, _object_spread({
                    localeId: localeId
                }, linkData))
            }, title);
        });
    };
    const renderLanguagePicker = ()=>{
        return /*#__PURE__*/ _jsx(LanguagePickerComponent, {
            dialogDirection: DIALOG_DIRECTIONS.ALIGN_TOP
        });
    };
    const renderAccessibilityStatementLink = ()=>{
        return /*#__PURE__*/ _jsx(AccessibilityStatementLinkComponent, {});
    };
    const shouldGetContactSalesButton = !hideContactSalesInFooter && (simulateContactSalesButtonInTheFooter || shouldGetContactSalesInTheFooter(abTests, true));
    const footerContactSalesClicked = ()=>{
        trackEvent(FOOTER_CONTACT_SALES_BUTTON_CLICKED);
    };
    const getContactSalesCTA = ()=>{
        return translate("header.contactSales");
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        partialVisibility: true,
        active: true,
        scrollCheck: true,
        onChange: onVisibilityChange,
        children: /*#__PURE__*/ _jsxs(StyledFooterBottomBarComponent, {
            className: "footer-bottom-bar-component",
            children: [
                shouldGetContactSalesButton && /*#__PURE__*/ _jsxs("div", {
                    className: "footer-contact-sales-section",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "footer-contact-sales-title",
                            children: /*#__PURE__*/ _jsx(Title, {
                                title: translate("footer.contactSalesTitle"),
                                titleSize: SM
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "footer-contact-sales-subtitle",
                            children: /*#__PURE__*/ _jsx(Paragraph, {
                                body: translate("footer.contactSalesSubTitle")
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "footer-contact-sales-button-wrapper",
                            children: /*#__PURE__*/ _jsx(RegularButton, {
                                buttonText: getContactSalesCTA(),
                                color: WORK_OS_IRIS_COLOR_NAME,
                                outline: true,
                                url: CONTACT_SALES_PAGE_LINK,
                                isWithArrow: false,
                                buttonSize: LG,
                                onClick: footerContactSalesClicked
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "footer-bottom-bar-both-sides-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "footer-bottom-bar-left-side",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "language-picker-and-security-logos-wrapper",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "language-picker-wrapper",
                                            children: renderLanguagePicker()
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "security-logos-wrapper",
                                            children: /*#__PURE__*/ _jsx(SecurityLogosComponent, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "social-statement-and-links-wrapper",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "palette-icons-wrapper",
                                            children: /*#__PURE__*/ _jsx(PaletteIconsComponent, {
                                                SocialFooterLinks: SocialFooterLinks
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "statement-and-links-wrapper",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "links-container",
                                                children: [
                                                    renderLinks(),
                                                    /*#__PURE__*/ _jsx(AllRightsReservedComponent, {})
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "footer-bottom-bar-right-side",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "app-store-icons",
                                    children: [
                                        /*#__PURE__*/ _jsx("a", {
                                            target: "_blank",
                                            className: "app-icon",
                                            href: ANDROID_APP_DOWNLOAD_LINK,
                                            title: "Download the monday android App from Google Play",
                                            children: /*#__PURE__*/ _jsx(GooglePlayBig, {})
                                        }),
                                        /*#__PURE__*/ _jsx("a", {
                                            target: "_blank",
                                            className: "app-icon",
                                            href: IOS_APP_DOWNLOAD_LINK,
                                            title: "Download the monday iOS App from the App Store",
                                            children: /*#__PURE__*/ _jsx(AppStoreBig, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "accessibility-statement-link-wrapper",
                                    children: renderAccessibilityStatementLink()
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default withGenericConfig(withAbTests(FooterBottomBarComponent));
